// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//
import { cartLineNotesStyles } from "@guestsupply/Overrides/Widgets/Cart/CartLineNotes";
import { createLinkIconStyles, xScreen } from "@guestsupply/XDL/Utilities";
import Plus from "@insite/mobius/Icons/Plus";
import { css } from "styled-components";

cartLineNotesStyles.wrapper = {
    css: css`
        width: 100%;
    `,
};
cartLineNotesStyles.editableNotesTextArea = {
    css: css`
        min-width: 100%;
        max-width: 100%;
        min-height: 50px;
    `,
};
// OOTB Style
cartLineNotesStyles.label = {
    css: css`
        button {
            background: none;
            border: none;
            padding: 0;
            font-size: 15px;
            cursor: pointer;
        }
    `,
};
cartLineNotesStyles.addNotesLink = {
    ...createLinkIconStyles(Plus, {
        css: css`
            display: flex;
            margin-top: 8px;
            ${xScreen("lte", "md")} {
                justify-content: end;
            }
        `,
        typographyProps: {
            size: 12,
        },
        icon: {
            iconProps: {
                size: 10,
            },
            position: "left",
        },
    }),
};
